import type { CreateJobPositionFormData } from '../schemas/jobPosition.schemas';
import type { CreateJobPositionRequest } from '../types/jobPosition.types';

export type TransformedJobPositionData = CreateJobPositionRequest;

export function transformFormDataForApi(data: CreateJobPositionFormData): CreateJobPositionRequest {
  return {
    title: data.title,
    description: data.description,
    location: data.location,
    employmentType: data.employmentType,
    remotePolicy: data.remotePolicy,
    experienceLevels: data.experienceLevels,
    salaryCurrency: data.salaryCurrency,
    skills: data.skills,
    requiredSkills: data.requiredSkills,
    preferredSkills: data.preferredSkills,
    technologies: data.technologies,
    languages: data.languages,
    certifications: data.certifications,
    jobPostingDate: data.jobPostingDate,
    applicationDeadline: data.applicationDeadline,
    department: data.department || undefined,
    requirements: data.requirements || undefined,
    responsibilities: data.responsibilities || undefined,
    benefits: data.benefits || undefined,
    yearsOfExperience: data.yearsOfExperience ?? undefined,
    salaryMin: data.salaryMin ?? undefined,
    salaryMax: data.salaryMax ?? undefined,
    educationLevel: data.educationLevel ?? undefined,
    educationField: data.educationField || undefined,
    startDate: data.startDate ? `${data.startDate}T00:00:00Z` : undefined,
    applicationUrl: data.applicationUrl || undefined,
  };
}
